import React from "react";
import { Helmet } from "react-helmet";

const ผู้ทำพินัยกรรม = () => {
  const TITLE = "ความสามารถของผู้ทำพินัยกรรม";

  return (
    <>
      <Helmet>
        <title>{TITLE}</title>
      </Helmet>

      <div className="content">
        <p>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ผู้ทำพินัยกรรม
          ต้องมีความสามารถสมบูรณ์ตามกฎหมาย ซึ่งสามารถทำพินัยกรรมได้ทุกคน
          แต่ถ้าผู้นั้นเป็น <b>ผู้เยาว์</b> <b>คนไร้ความสามารถ</b>{" "}
          <b>คนวิกลจริต</b> หรือ<b>คนเสมือนไร้ความสามารถ</b>{" "}
          ต้องมีการพิจารณาความสามารถของบุคคลเหล่านี้ต้องไปซึ่งสามารถแยกพิจารณาได้ดังหัวข้อเนื้อหา
        </p>

        {/* 1. กรณีผู้เยาว์ทำพินัยกรรม */}
        <h2 id="initial-header">1. กรณีผู้เยาว์ทำพินัยกรรม</h2>
        <p>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ผู้เยาว์
          สามารถทำพินัยกรรมได้ต่อเมื่อมีอายุครบ 25 ปีบริบูรณ์
          และต้องเป็นการทำพินัยกรรมด้วยตัวเองเท่านั้น
          ผู้อื่นไม่สามารถทำให้ได้ถึงแม้จะเป็นทายาทโดยธรรมก็ตาม
          นอกจากนี้ไม่ได้คำนึงว่าผู้เยาว์ได้ทำการสมรสแล้วหรือไม่
          แต่ถ้าผู้เยาว์ได้ทำพินัยกรรมในอายุที่ยังไม่ครบ 25 ปีบริบูรณ์
          พินัยกรรมที่ได้ทำไปนั้นถือเป็นโมฆะในทันที
        </p>

        {/* 2. กรณีคนไร้ความสามารถทำพินัยกรรม */}
        <h2 id="second-header">2. กรณีคนไร้ความสามารถทำพินัยกรรม</h2>
        <p>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ถ้าบุคคลนั้นศาลซึ่งได้สั่งว่าเป็นคนไร้ความสามารถแล้ว
          บุคคลนั้นจะไม่สามารถทำพินัยกรรมได้เลย
          ไม่ว่าบุุคลน้ันจะทำพินัยกรรมขณะที่จริตปกติหรือไม่ก็ตาม
          ถ้าบุคคลนั้นได้ทำลงไปแล้ว พินัยกรรมนั้นย่อมเป็นโมฆะทันที
        </p>

        {/* 3. กรณีคนวิกลจริตทำพินัยกรรม */}
        <h2 id="third-header">3. กรณีคนวิกลจริตทำพินัยกรรม</h2>
        <p>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ถ้าบุคคลนั้นเป็นบุคคลวิกลจริตได้ทำพินัยกรรมขึ้นมาในขณะที่ตนวิกลจริต
          พินัยกรรมนั้นย่อมเป็นอันเสียเปล่าทันที
          แต่ถ้าบุคคลนั้นเป็นบุคคลวิกลจริต แต่มีอาการเป็น ๆ หาย ๆ
          และได้ทำพินัยกรรมขึ้นมาในขณะที่ตนยังมีจริตปกติ
          พินัยกรรมนั้นย่อมสมบูรณ์แบบ ไม่ถูกโมฆะ
        </p>

        {/* 4. กรณีคนเสมือนไร้ความสามารถทำพินัยกรรม */}
        <h2 id="fourth-header">4. กรณีคนเสมือนไร้ความสามารถทำพินัยกรรม</h2>
        <p>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;บุคคลซึ่งเป็นคนเสมือนไร้ความสามารถนั้นสามารถทำพินัยกรรมได้โดยสมบูรณ์
          โดยไม่ต้องรับความยินยอมจากผู้พิทักษ์
          หรือผู้ปกครองที่ดูแลของคนเสมือนไร้ความสามารถบุคคลนั้น
          และกฎหมายไม่ได้บัญญัติไว้ว่าพินัยกรรมที่บุคคลนั้นได้ทำไปจะมีความเสื่อมเสียประการใด
          ดังนั้นพินัยกรรมที่คนเสมือนไร้ความสามารถได้ทำลงไปจึงเป็นพินัยกรรมที่สมบูรณืแบบ
          ไม่ถูกโมฆะ
        </p>
      </div>

      <div>
        <h1 className="ml-4">แนะนำสำหรับคุณ</h1>
        <ul className="list__post">
          <li>
            <a className="text-indigo-700 underline" href="/thai/6">
              รูปแบบพินัยกรรมของพินัยกรรม
            </a>
          </li>
          <li>
            <a className="text-indigo-700 underline" href="/thai/8">
              ความสามารถของผู้รับพินัยกรรม
            </a>
          </li>
        </ul>
      </div>
    </>
  );
};

export default ผู้ทำพินัยกรรม;
